module.exports = __webpack_public_path__ + "img/contact7.db872330.png";